<template>
  <div class="container" v-wechat-title="$route.meta.title">
    <!-- 营业报表 -->
    <div class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen">
        <div @click="goWhichPage(1)" class="disp-just-bet-ali-cen width100">
          <div class="title-div"><img src="../assets/indexImage/yingyebaobiao@2x.png" alt="">营业报表</div>
          <div class="right">查看更多</div>
        </div>
      </div>
      <div class="wrap disp-ali-cen">
        <div class="info info1 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative">今日接待总数<p @click="checkQues('接待总数_1')" class="ques"></p></div>
          <div>{{getOneDimension("接车台次统计",0)}}</div>
          <div>昨日接待数:{{getOneDimension("昨日接车台次统计",0)}}<div></div></div>
        </div>
        <div class="info info1 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative">今日预约到店（台次）<p @click="checkQues('预约到店_1')" class="ques"></p></div>
          <div>
            <span style="font-size: 0.34rem;"></span>
            {{getOneDimension("预约到店台次统计",0)}}
          </div>
          <div>昨日预约到店:{{getOneDimension("昨日预约到店台次",0)}}</div>
        </div>
      </div>
    </div>
    <!-- 销售报表 -->
    <div v-if="Admin" class="onePart">
      <div @click="goWhichPage(2)" class="titlePart disp-just-flsta-ali-cen">
        <div class="disp-just-bet-ali-cen width100">
          <div class="title-div"><img src="../assets/indexImage/xiaoshoubaobiao@2x.png" alt="">销售报表</div>
          <div class="right">查看更多</div>
        </div>
      </div>
      <div style class="wrap disp-ali-cen">
        <div class="info info2 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative">今日营业额（元）<p @click="checkQues('今日营业额_1')" class="ques"></p></div>
          <div>
            <span style="font-size: 0.34rem;">￥</span>
            {{getOneDimension("营业额",0)}}
          </div>
          <div>昨日营业额:<span style="font-size: 0.34rem;">￥</span>{{getOneDimension("昨日营业额",0)}}</div>
        </div>
        <div class="info info2 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative">今日毛利（元）<p @click="checkQues('今日毛利_1')" class="ques"></p></div>
          <div>
            <span style="font-size: 0.34rem;">￥</span>
            {{getOneDimension("销售总毛利",0)}}
          </div>
          <div>昨日毛利:<span style="font-size: 0.34rem;">￥</span>{{getOneDimension("昨日销售总毛利",0)}}</div>
        </div>
        <div class="info info2 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative">今日客单价（元）<p @click="checkQues('今日客单价_1')" class="ques"></p></div>
          <div>
            <span style="font-size: 0.34rem;">￥</span>
            {{getOneDimension("客单价",0)}}
          </div>
          <div>昨日客单价:<span style="font-size: 0.34rem;">￥</span>{{getOneDimension("昨日客单价",0)}}</div>
        </div>
        <div class="info info2 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative">今日会员卡销售额（元）<p @click="checkQues('会员卡总销售额_1')" class="ques"></p></div>
          <div>
            <span style="font-size: 0.34rem;">￥</span>
            {{getOneDimension("会员卡总销售额",0)}}
          </div>
          <div>昨日销售额:<span style="font-size: 0.34rem;">￥</span>{{getOneDimension("昨日会员卡总销售额",0)}}</div>
        </div>
      </div>
    </div>
    <!-- 采购报表 -->
    <div v-if="Admin" class="onePart">
      <div  @click="goWhichPage(3)" class="titlePart disp-just-flsta-ali-cen">
        <div class="disp-just-bet-ali-cen width100">
          <div class="title-div"><img src="../assets/indexImage/caigoubaobiao@2x.png" alt="">采购报表</div>
          <div class="right">查看更多</div>
        </div>
      </div>
      <div class="wrap disp-ali-cen">
        <div class="info info3 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative">今日采购货值（元）<p @click="checkQues('今日采购货值_1')" class="ques"></p></div>
          <div>{{getOneDimension("采购总货值",0)}}</div>
          <div>昨日采购:<span style="font-size: 0.34rem;">￥</span>{{getOneDimension("昨日采购总货值",0)}}</div>
        </div>
        <div class="info info3 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative">今日采购数量（件）<p @click="checkQues('今日采购数量_1')" class="ques"></p></div>
          <div>{{getOneDimension("采购件数",0)}}</div>
          <div>昨日采购:{{getOneDimension("昨日采购件数",0)}}</div>
        </div>
      </div>
    </div>
    <!-- 库存报表 -->
    <div v-if="Admin" class="onePart">
      <div @click="goWhichPage(4)" class="titlePart disp-just-flsta-ali-cen">
        <div class="disp-just-bet-ali-cen width100">
          <div class="title-div"><img src="../assets/indexImage/kucunbaobiao@2x.png" alt="">库存报表</div>
          <div class="right">查看更多</div>
        </div>
      </div>
      <div style class="wrap disp-ali-cen">
        <div class="info info4 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative">今日入库货值（元）<p @click="checkQues('今日入库货值_1')" class="ques"></p></div>
          <div>
            <span style="font-size: 0.34rem;">￥</span>
            {{getOneDimension("入库总货值",0)}}
          </div>
          <div>昨日入库:<span style="font-size: 0.34rem;">￥</span>{{getOneDimension("昨日入库总货值",0)}}</div>

        </div>
        <div class="info info4 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative">今日出库货值（元）<p @click="checkQues('今日出库货值_1')" class="ques"></p></div>
          <div>
            <span style="font-size: 0.34rem;">￥</span>
            {{getOneDimension("出库总货值",0)}}
          </div>
          <div>昨日出库:<span style="font-size: 0.34rem;">￥</span>{{getOneDimension("昨日出库总货值",0)}}</div>
        </div>
        <div class="info info4 info_1 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative">当前库存货值（元）<p @click="checkQues('商品大类库存货值_1')" class="ques"></p></div>
          <div>
            <span style="font-size: 0.34rem;">￥</span>
            {{getOneDimension("库存总货值",0)}}
          </div>
          <div>{{LastTime}}</div>
        </div>
      </div>
    </div>
    <!-- 客户报表 -->
    <div v-if="Admin" class="onePart">
      <div  @click="goWhichPage(5)" class="titlePart disp-just-flsta-ali-cen">
        <div class="disp-just-bet-ali-cen width100">
          <div class="title-div"><img src="../assets/indexImage/kehubaobiao@2x.png" alt="">客户报表</div>
          <div class="right">查看更多</div>
        </div>
      </div>
      <div style class="wrap disp-ali-cen">
        <div class="info info5 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative">今日新增客户（人）<p @click="checkQues('今日新增客户_1')" class="ques"></p></div>
          <div>{{getOneDimension("新增客户总数",0)}}</div>
          <div>昨日新增:{{getOneDimension("昨日新增客户总数",0)}}</div>
        </div>
        <div class="info info5 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative">累计客户总数<p @click="checkQues('累计客户总数_1')" class="ques"></p></div>
          <div>{{getOneDimension("客户总数",0)}}</div>
          <div>{{LastTime}}</div>
        </div>
      </div>
      <!-- <div class="titlePart disp-just-flsta-ali-cen">
        <img src="../assets/indexImage/kehugoucheng@2x.png" alt />客户构成（人）
      </div>
      <div id="pieOne" :style="{width:'100%',height:'5.06rem'}"></div>
       <div class="titlePart disp-just-flsta-ali-cen">
        <img src="../assets/indexImage/huiyuan@2x.png" alt="">会员类型占比（人）
      </div>
      <div id="pieTwo" :style="{width:'100%',height:'6.06rem'}"></div> -->
    </div>
 
 
    <!-- 财务报表 -->
    <div v-if="Admin" class="onePart">
      <div @click="goWhichPage(6)"  class="titlePart disp-just-flsta-ali-cen">
         <div class="disp-just-bet-ali-cen width100">
          <div class="title-div"><img src="../assets/indexImage/caiwu@2x.png" alt="">财务报表</div>
          <div class="right">查看更多</div>
        </div>
      </div>
      <div style class="wrap disp-ali-cen">
        <div class="info info6 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative">今日实收（元）<p @click="checkQues('今日实收_1')" class="ques"></p></div>
          <div>
            <span style="font-size: 0.34rem;">￥</span>
            {{getOneDimension("实收款总金额",0)}}
          </div>
          <div>昨日实收:<span style="font-size: 0.34rem;">￥</span>{{getOneDimension("昨日实收款总金额",0)}}</div>
        </div>
        <div class="info info6 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative">今日实付（元）<p @click="checkQues('今日实付_1')" class="ques"></p></div>
          <div>
            <span style="font-size: 0.34rem;">￥</span>
            {{getOneDimension("实付款总金额",0)}}
          </div>
          <div>昨日实付:<span style="font-size: 0.34rem;">￥</span>{{getOneDimension("昨日实付款总金额",0)}}</div>
        </div>
        <div class="info info6 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative">今日优惠券发放金额（元）<p @click="checkQues('今日优惠券发放金额_1')" class="ques"></p></div>
          <div>
            <span style="font-size: 0.34rem;">￥</span>
            {{getOneDimension("优惠券发放总金额",0)}}
          </div>
          <div>昨日发放:<span style="font-size: 0.34rem;">￥</span>{{getOneDimension("昨日优惠券发放总金额",0)}}</div>
        </div>
        <div class="info info6 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative">今日拼团成交（元）<p @click="checkQues('今日拼团成交金额_1')" class="ques"></p></div>
          <div>
            <span style="font-size: 0.34rem;">￥</span>
            {{getOneDimension("拼团成交总金额",0)}}
          </div>
          <div>昨日成交:<span style="font-size: 0.34rem;">￥</span>{{getOneDimension("昨日拼团成交总金额",0)}}</div>
        </div>
        <div class="info info6 info_1 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative">今日秒杀成交（元）<p @click="checkQues('今日秒杀成交金额_1')" class="ques"></p></div>
          <div>
            <span style="font-size: 0.34rem;">￥</span>
            {{getOneDimension("秒杀成交总金额",0)}}
          </div>
          <div>昨日秒杀:<span style="font-size: 0.34rem;">￥</span>{{getOneDimension("昨日秒杀成交总金额",0)}}</div>
        </div>
      </div>
    </div>

    <!-- 营销报表 -->
    <div v-if="Admin" class="onePart">
      <div  @click="goWhichPage(7)" class="titlePart disp-just-flsta-ali-cen">
        <div class="disp-just-bet-ali-cen width100">
          <div class="title-div"><img src="../assets/indexImage/caiwu@2x.png" alt="">营销报表</div>
          <div class="right">查看更多</div>
        </div>
      </div>
      <div style class="wrap disp-ali-cen">
        <div class="info info2 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative">今日优惠券发放总数量<p @click="checkQues('今日优惠券发放数量_1')" class="ques"></p></div>
          <div>{{getOneDimension("优惠券发放总数量",0)}}</div>
          <div>昨日发放:{{getOneDimension("昨日优惠券发放总数量",0)}}</div>
        </div>
        <div class="info info2 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative">今日拼团成交总单数<p @click="checkQues('今日拼团成交单数_1')" class="ques"></p></div>
          <div>{{getOneDimension("拼团成交总单数",0)}}</div>
          <div>昨日成交:{{getOneDimension("昨日拼团成交总单数",0)}}</div>
        </div>
        <div class="info info2 info_1 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative">今日秒杀成交总单数<p @click="checkQues('今日秒杀成交单数_1')" class="ques"></p></div>
          <div>{{getOneDimension("秒杀成交总单数",0)}}</div>
          <div>昨日成交:{{getOneDimension("昨日秒杀成交总单数",0)}}</div>
        </div>
      </div>
    </div>
     <div class="divPlaceholder">&nbsp;</div>
    <!-- loading的显示隐藏 -->
    <!-- <van-popup :close-on-click-overlay="false" v-model="loadShow">
      <van-loading size="24px" vertical>加载中...</van-loading>
    </van-popup> -->
    <Loading v-show="loadShow"></Loading>
    <van-popup
      v-model="popupShow"
      closeable
      round
      position="bottom"
      :style="{ height: '30%' }"
    >
      <p class="popup-p popup-p1">计算方式</p>
      <p class="popup-p popup-p2">{{popupTitle}}</p>
      <p class="popup-p popup-p3">{{popupContent}}</p>
    </van-popup>
  </div>
</template>
<script>
  import Vue from 'vue'
  import util from '../../static/js/util'
  import explain from '../../static/js/calculationExplain'
  import baseUrl from '../../static/js/basedata.js'
  import {
    Loading,Dialog,Popup 
  } from 'vant';
  Vue.use(Loading);
  Vue.use(Dialog);
  Vue.use(Popup);

  export default {
    name: 'InfoPage',
    data() {
      return {
        RptData: {},
        loadShow: false,
        Admin:true,
        popupShow:false,//底部弹框是否显示
        popupTitle:'弹框标题',//弹框标题
        popupContent:'弹框内容',//弹框标题
      }
    },
computed: {
        LastTime: function() {
            if (this.RptData.LastUpdateTime){
             var timeS = this.RptData.LastUpdateTime.replace(/-/g,"/"); 
                return (
                    "更新时间:" +
                    new Date(timeS).format("MM/dd hh:mm")
                );}
            return "";
        }
    },
    methods: {
      goWhichPage(num){
        console.log(num)
        var url = '';
        if(num == 1){
          url = './yingyebaobiao'
        }else if(num == 2){
          url = './xiaoshoubaobiao'
        }else if(num == 3){
          url = './caigoubaobiao'
        }else if(num == 4){
          url = './kucunbaobiao'
        }else if(num == 5){
          url = './kehubaobiao'
        }else if(num == 6){
          url = './caiwubaobiao'
        }else if(num == 7){
          url = './yingxiaobaobiao'
        }
        this.$router.push({
          path: url,
          query: {

          }
        })
      },
      checkQues(key){
        this.popupShow = true;
        this.popupTitle = key.split('_')[0];
        this.popupContent = explain.explain[key];
      },
      getOneDimension(subTypeName,def) {
        return this.$util.getOneDimension(this.RptData.Items,subTypeName,def)
      },
      getTwoDimension(subTypeName, defX, defY) {
        return this.$util.getTwoDimension(this.RptData.Items,subTypeName, defX, defY)
      },
      loadData() {
        var that = this;
        that.loadShow = true;
        this.$api.get("/AppReport", {ReportType:this.$util.AppReportType.首页看板}, function (res) {
          that.RptData = res;
          that.drawPie();
          that.loadShow = false;
        }, function (err) { that.loadShow = false; });
      },
      drawPie() {

        var pieOneData = this.getTwoDimension("新老客户构成", "新客户", "0");
        
        // 基于准备好的dom，初始化echarts实例
        this.$echarts.init(document.getElementById('pieOne'))
          .setOption( this.$util.PieOption(pieOneData));

 

        var pieTwoData = this.getTwoDimension("客户会员类型占比", "会员", "0");
        this.$echarts.init(document.getElementById('pieTwo'))
          .setOption( this.$util.PieOption(pieTwoData));
      }
    },
    mounted() {
      this.Admin=this.$api.IsAdmin();
      var date = this.$dateUtil.today();
      this.beginDay = date.Begin;
      this.endDay = date.End;
      this.loadData();
       phoneDevice.setTitle(this.$route.meta.title || "");
    }
  }
</script>

<style>
@import url("../../static/css/common.css");
.wrap .info1 {
  background-image: url(../assets/indexImage/img10.png);
}
.wrap .info_1 {
  background-image: url(../assets/indexImage/img10.png);
  background-position: center;
  background-size: cover;
}
.wrap .info2 {
  background-image: url(../assets/indexImage/img2.png);
}

.wrap .info3 {
  background-image: url(../assets/indexImage/img4.png);
}

.wrap .info4 {
  background-image: url(../assets/indexImage/img6.png);
}

.wrap .info5 {
  background-image: url(../assets/indexImage/img12.png);
}

.wrap .info6 {
  background-image: url(../assets/indexImage/img8.png);
}
.div-relative .ques2{
  width: 0.44rem;
  height: 0.44rem;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAVFBMVEUAAABmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZu41ZBAAAAG3RSTlMAJsuX+cRVA/bbjdNIQCqcaGQW8uTmMrZ+dnQK2+b1AAABCklEQVQ4y+1Uy3LDIAyMEWAefoFt0nb//z97SHlMwXQ6OeQSXUDDIiTtotvbXmSzEYdShzDzX8jRaVjapNzIQruxhx0YpyU6C3E2XGOnPZ7Gu/t0ieXrr3fHlV+gB7UWZYbHuu7tTBjLcT8B+YjNWAvreBHjDtDPe9w1wJoKJ2gbr5JucIGlXcqCmh1j894bbbJnTQUWlGMJBYTkkqjA55bi3v0O7tPJdlZgJeNOLhNQRJOqBU5GwFcXfG55fwDDrUijV2AAyt6S6LXuAyi7ZU2PFAbMPvRIyXR74BxFSpp0T0gSOIRMwuWuJ1HPYKPko0Q74o/sRfE/8a36H/b5UVAPmf+Mr7e9xr4BTfYMVLOZZVEAAAAASUVORK5CYII=);
  background-position: center;
  background-size: contain;
  position: absolute;
  right: 0;
  top: 0;
}
.wrap .ques{
  width: 0.44rem;
  height: 0.44rem;
  background-image: url(../assets/indexImage/ques.png);
  background-position: center;
  background-size: contain;
  position: absolute;
  right: 0;
  top: 0;
}
.title-div{
  display: flex;
  align-items: center;
}
.titlePart .right{
  color: #999999;
  float: right;
  font-size: 0.24rem;
  padding-right: 0.3rem;
  background: url(../assets/you.png) no-repeat 100% center;
  background-size: contain;
}
.width100{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/shujufenxi.vue